import { EngagementClosingDate } from './engagement-closing-date.model';

export const CLOSING_DATE_MARKER_COLOR = '#cb9700';

export interface TimelineClosingDate {
    date: string;
    isAgreed: boolean;
    noLongerFits: boolean;
}

export const toTimelineClosingDate = (
    closingDate: EngagementClosingDate | undefined,
    engagementId: number
): TimelineClosingDate | null => {
    if (closingDate?.engagementId !== engagementId) {
        return null;
    }

    const date = closingDate.officialClosingDate ?? closingDate.defaultClosingDate;

    if (!date) {
        return null;
    }

    return {
        date,
        isAgreed: !!closingDate.officialClosingDate,
        noLongerFits: !!closingDate.timelineNoLongerFits,
    };
};
